import { Routes } from '@angular/router';
import { MainPageComponent } from './container/main-page.component';

export const MAIN_PAGE_ROUTES: Routes = [
    {
        path: '',
        component: MainPageComponent,
    },
];
